/**
 * Checks if the given regular expression matches any values in the extra profile data of a profile.
 *
 * @param {Object} p - The profile object containing extra profile data
 * @param {RegExp} exp - The regular expression to match against
 * @return {boolean} Returns true if a match is found, otherwise false
 */
export function textInProfileFields(p, exp) {
    if (!p?.extra_profile_data) return false;

    // Regular for loops for speed (Michiel: I hope, didn't compare)
    for (var i = 0; i < p.extra_profile_data.length; i++) {
        var value = p.extra_profile_data[i].value;
        for (var j = 0; j < value.length; j++) {
            if (value[j] && value[j].match(exp)) {
                return true;
            }
        }
    }

    return false;
}
